import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.main');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.main/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutMainComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef,@Inject( Router)  public router: Router) { }

    public browserWarning: string = '';

    public async ngOnInit() {
        await this.service.init(this);
        this.checkBrowser();
    }

    public checkBrowser() {
        if (!window.AudioContext && !(window as any).webkitAudioContext) {
            this.browserWarning = '이 브라우저는 음역대 테스트를 지원하지 않습니다. Chrome, Safari, Edge를 사용해주세요.';
        } else if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            this.browserWarning = '마이크 접근이 지원되지 않습니다. HTTPS 환경의 Chrome, Safari를 사용해주세요.';
        }
        if (this.browserWarning) this.service.render();
    }

    public isActive(path: string) {
        if (path === '/') return location.pathname === '/';
        return location.pathname === path || location.pathname.startsWith(path + '/');
    }

    public dismissWarning() {
        this.browserWarning = '';
        this.service.render();
    }

    public goFavorites() { this.service.href('/favorites'); }
}

export default LayoutMainComponent;